/*@ngInject*/
const RuleActionsUtil = function ($rootScope, $state, ruleMediator, ruleModel, localization, loadingBarHandler, ruleEntryStatus, modalUtil, coreConstant, umStudioConstant) {

    localization.getTranslationByKey('ruleBuilderHeader').then((translations) => {

        this.translations = translations;

        this.saveRule = function (rule) {
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'savingRuleLoadingBar'));
            let promise = ruleMediator.updateRule(rule).then((updatedRule) => {
                ruleModel.updateRule(updatedRule);

                if (updatedRule.status === ruleEntryStatus.STATUS_INVALID) {
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(this.translations, 'savingRuleSuccessWithValidationErrorsLoadingBar'));
                } else {
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(this.translations, 'savingRuleSuccessLoadingBar'));
                }
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        };

        this.discardChanges = function () {
            modalUtil.showConfirmationModal(null, null, null, 'ruleBuilderHeader.discard', null, true, () => {
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'discard.success'));
                $state.reload();
            });
        };

        this.delete = function (rule) {
            modalUtil.showConfirmationModal(
                rule.id,
                null,
                null,
                'ruleBuilderHeader.delete',
                null,
                /*hideLoadingBar*/true,
                handleDeleteConfirm);

            function handleDeleteConfirm() {
                loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'deleteRuleLoadingBar'));
                return ruleMediator.deleteRule(rule.id).then(function () {
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'deleteRuleSuccessLoadingBar'));
                    $state.go('configuration.rulesBrowser', {});
                });
            }
        };

        this.activateRule = function (rule) {
            return ruleMediator.activateRule(rule.id).then((updatedRule) => {
                ruleModel.updateRule(updatedRule);
                $rootScope.$broadcast(umStudioConstant.event.RULE_STATUS_UPDATED);
            });
        };

        this.deactivateRule = function (rule) {
            return ruleMediator.deactivateRule(rule.id).then((updatedRule) => {
                ruleModel.updateRule(updatedRule);
                $rootScope.$broadcast(umStudioConstant.event.RULE_STATUS_UPDATED);
            });
        };
    });
};

angular.module('ums.configuration')
    .service('ruleActionsUtil', RuleActionsUtil);
